import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from 'react-i18next'

import moment from 'moment';
import 'moment/locale/zh-hk'
import {STATIC_FILE_URL, STATIC_LOCAL_FILE_URL} from "./api";

moment.updateLocale('en', {
    longDateFormat : {
      LL: "DD MMMM YYYY",
    }
});
  
moment.updateLocale('zh-hk', {
weekdaysShort: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
});

i18n
.use(Backend)
.use(LanguageDetector)
.use(initReactI18next)
.init({
    backend: {
        loadPath: () => {
            return `${STATIC_LOCAL_FILE_URL}/locales/{{lng}}/{{ns}}.json`
        },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    },
    react: {
        wait: true
    },
    detection: {
        order: ['cookie', 'localStorage', "navigator"],
        caches: ['localStorage', 'cookie']
    }
}, () => {
    moment.locale(i18n.language)
})

export default i18n;